module.exports = "https://cdn.hellotech.com/client-assets/home-office-setup-mobile_8eb0389e4129053229f9b6d35d9cc2d0.png";